import type { UIApiConfig } from '@sydle/ui-api';
import { DefaultRestService } from '@sydle/ui-api';
import { getConfig } from '@sydle/ui-utils';

const headers = {
  'Content-Type': 'application/json',
  'X-Explorer-Account-Token': getConfig<UIApiConfig>('ui-api')?.ORGANIZATION_IDENTIFIER,
  Authorization: getConfig<UIApiConfig>('ui-api')?.REQUEST_PARAMS?.headers?.Authorization,
};

export const anonymousRestService = new DefaultRestService(undefined, {
  headers,
  additionalParams: { suppressAlerts: true },
});
